import React from 'react';

import { ColumnDescription } from "react-bootstrap-table-next";
import { IGraduationPrognosis } from "../types/types";
import { Prognosis, tryParseInt } from "../utilities";

export function GetGraduationPrognosisColumns(graduationPrognosis: IGraduationPrognosis, className: string): 
    ({ 
        columns: ColumnDescription[], 
        extendedColumns: ColumnDescription[], 
        expandablePersonalColumns: ColumnDescription[],
        personalColumnData: { width: number }[]
    }) 
{
    let programCourses: any = {};
    let individualCourses: any = {};
    let programType: string | undefined;

    graduationPrognosis.programMandatoryCourses.forEach(e => {
        programCourses[e.courseFilterMask] = { id: e.courseFilterMask, displayName: e.courseDisplayName, type: e.courseType }
        programType = e.type;
    });

    const programCourseFilter = graduationPrognosis.programMandatoryCourses.map(e => {
        return e.courseFilterMask;
    });

    graduationPrognosis.studentView.forEach((e, index) => {

        var coursedata: any = {};

        for(var i = 0; i < e.studentForecastView.length; i++) {
            const forecast = e.studentForecastView[i];

            coursedata[forecast.courseName] = {
                grade: forecast.grade,
                prognosis: forecast.prognosis,
                prevPrognosis: forecast.prevPrognosis
            }

            if(programCourseFilter.indexOf(forecast.courseName) == -1) {
                individualCourses[forecast.courseName] = { 
                    id: forecast.courseName,
                    displayName: forecast.courseDisplayName
                };
            }
        }
        
        //programType = programType == undefined || e.programType != '-' ? e.programType : programType;
    });

    let preEvalColumns : ColumnDescription[] = [];
    let extendedColumns : ColumnDescription[] = [];

    let year = 0; //grade

    let expandablePersonalColumns: ColumnDescription[]  = [];
    let personalColumnData = [];

    switch (programType) {

        case 'HP': case 'YP': {

            let numbers = className.match( /\d+/);
            let num = tryParseInt(numbers != null && numbers.length > 0 ? numbers[0] : "0", 0);

            let date = new Date();
            let currYear = date.getFullYear();
            let currMonth = date.getMonth();

            year = (currYear % 100) - num + (currMonth > 5 ? 1 : 0);

            preEvalColumns = Object.keys(programCourses)
                .sort((a, b) => {
                    return internal.sortCourseId(a) > internal.sortCourseId(b) ? -1 : 1
                })
                .map((key, index) => {
                    return internal.constructAdditionalColumn(programCourses[key], (9000 - index));
                })
            extendedColumns = Object.keys(individualCourses).map((key, index) => {
                    return internal.constructAdditionalColumn(individualCourses[key], (5000-index));
                })

            expandablePersonalColumns.push({
                dataField: 'programName',
                text: 'Utbildningsväg',
                headerStyle: {
                    width: '10rem',
                    left:'26rem',
                    zIndex: 10000
                },
                headerClasses: 'sticky-x',
                classes: 'sticky-x',
                style: {
                    wordBreak: 'break-word',
                    left:'26rem',
                    zIndex: 10000
                }
            });
            personalColumnData.push({width: 10});

            break;
        }
        //Grundskola
        default: {
            preEvalColumns = Object.keys(individualCourses)
            .sort((a, b) => internal.sortCourseId(a) > internal.sortCourseId(b) ? -1 : 1)
            .map((key, index) => {
                return internal.constructAdditionalMiddleSchoolColumn(individualCourses[key], true, (9000 - index));
            })
            extendedColumns = Object.keys(individualCourses)
            .sort((a, b) => internal.sortCourseId(a) > internal.sortCourseId(b) ? -1 : 1)
            .map((key, index) => {
                return internal.constructAdditionalMiddleSchoolColumn(individualCourses[key], false, (5000 - index));
            })
        }
    }

    const evalColumns = internal.getEvalColumns(programType || "", year)

    return {
        columns: [...preEvalColumns, ...evalColumns],
        extendedColumns: extendedColumns,
        expandablePersonalColumns,
        personalColumnData
    }
}

abstract class internal {
    
    public static getPointsColor = function (programType: string, points: number, total: boolean, year: number) {
        if(total) {
            switch (programType) {
                case 'HP': case 'YP': {
                    return year > 2 ? (points >= 2250 ? 'bg-light-green' : 'bg-light-red') : 'bg-grey';
                }
                default: {
                    return '';
                }
            }
        }
        else {
            return '';
        }
    }

    public static getEvalColumns = function (programType: string, year: number) : ColumnDescription<any, any>[] {
        switch (programType) {
            case "HP": {
                return [{
                    dataField: 'exam',
                    text: 'Examen',
                    formatter: () => '',
                    headerStyle: {
                        width: '6rem',
                        textAlign: 'center'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => cell ? "bg-green" : "bg-red"
                }, {
                    dataField: 'coreSubjectsComplete',
                    text: 'Kärnämnen',
                    headerFormatter: () => (<div title={"Godkänt i grundläggande svenska/sva, matematik, engelska"}>Engelska<br/>Matematik<br/>Svenska/SVA</div>),
                    formatter: () => '',
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '9rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => cell ? "bg-light-green" : "bg-light-red"
                }, {
                    dataField: 'totalPoints',
                    text: 'Betygspoäng',
                    headerFormatter: () => (<div title={"Minst 2250 betygspoäng"}>Betygspoäng</div>),
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '8rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell, row) => internal.getPointsColor(row.programType, cell, true, year) 
                }, {
                    dataField: 'invalidPoints',
                    text: 'Underkända betygspoäng',
                    headerFormatter: () => (<div title={"Mindre än 250 betygspoäng underkänt"} style={{textAlign: 'center'}}>Underkända<br/>betygspoäng</div>),
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '8rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => year > 2 ? 'bg-grey' : cell > 250 ? "bg-light-red" : "bg-light-green"
                }, {
                    //hsAveragePoints
                    
                    dataField: 'hsAveragePoints',
                    text: 'GBP',
                    headerFormatter: () => (<div title={"Genomsnittligt betygspoäng"} style={{textAlign: 'center'}}>GBP</div>),
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '5rem'
                    },
                    headerClasses: 'sticky-y',
                    formatter: (cell) => cell.toFixed(1).toString()
                    //classes: (cell) => year > 2 ? 'bg-grey' : cell > 250 ? "bg-light-red" : "bg-light-green"
                }];
            }
            case "YP": {
                return [{
                    dataField: 'exam',
                    text: 'Examen',
                    formatter: () => '',
                    headerStyle: {
                        width: '6rem',
                        textAlign: 'center'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => cell ? "bg-green" : "bg-red"
                }, {
                    dataField: 'coreSubjectsComplete',
                    text: 'Kärnämnen',
                    headerFormatter: () => (<div title={"Godkänt i grundläggande svenska/sva, matematik, engelska"}>Engelska<br/>Matematik<br/>Svenska/SVA</div>),
                    formatter: () => '',
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '9rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => cell ? "bg-light-green" : "bg-light-red"
                }, {
                    dataField: 'programPoints',
                    text: 'programpoäng',
                    headerFormatter: () => (<div title={"Minst 400 programgemensamma poäng"} style={{textAlign: 'center'}}>Program<br/>poäng</div>),
                    style: {
                        textAlign: 'center'
                    },
                    headerStyle: {
                        width: '6rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => cell >= 400 ? "bg-light-green" : "bg-light-red"
                }, {
                    dataField: 'totalPoints',
                    text: 'Betygspoäng',
                    headerFormatter: () => (<div title={"Minst 2250 betygspoäng"}>Betygspoäng</div>),
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '8rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell, row) => internal.getPointsColor(programType, cell, true, year) 
                }, {
                    dataField: 'invalidPoints',
                    text: 'Underkända betygspoäng',
                    headerFormatter: () => (<div title={"Mindre än 250 betygspoäng underkänt"} style={{textAlign: 'center'}}>Underkända<br/>betygspoäng</div>),
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '8rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => year > 2 ? 'bg-grey' : cell > 250 ? "bg-light-red" : "bg-light-green"
                }, {
                    //hsAveragePoints
                    
                    dataField: 'hsAveragePoints',
                    text: 'GBP',
                    headerFormatter: () => (<div title={"Genomsnittligt betygspoäng"} style={{textAlign: 'center'}}>GBP</div>),
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '5rem'
                    },
                    headerClasses: 'sticky-y',
                    formatter: (cell) => cell.toFixed(1).toString()
                    //classes: (cell) => year > 2 ? 'bg-grey' : cell > 250 ? "bg-light-red" : "bg-light-green"
                }];
            }
            default: {
                return [{
                    dataField: 'basicHS',
                    text: 'Grundläggande gymnasiebehörighet',
                    isDummyField: true,
                    headerFormatter: () => <div title={"Godkänt i kärnämnen och 5 andra ämnen"} style={{textAlign:'center'}}>Grundläggande<br/>gymnasiebehörighet</div>,
                    style: {
                        textAlign: 'center'
                    },
                    headerStyle: {
                        width: '12rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (_, row) => row.msValidCourseCount >= 5 && row.coreSubjectsComplete ? "bg-light-green" : "bg-light-red"
                },{
                    dataField: 'uniHS',
                    text: 'GrundläggaHögskoleförberedande gymnasiebehörighet',
                    isDummyField: true,
                    headerFormatter: () => <div title={"Godkänt i kärnämnen och 8 andra ämnen"} style={{textAlign:'center'}}>Högskoleförberedande<br/>gymnasiebehörighet</div>,
                    style: {
                        textAlign: 'center'
                    },
                    headerStyle: {
                        width: '13rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (_, row) => row.msValidCourseCount >= 8 && row.coreSubjectsComplete ? "bg-light-green" : "bg-light-red"
                }, {
                    dataField: 'coreSubjectsComplete',
                    text: 'Kärnämnen',
                    headerFormatter: () => (<div title={"Godkänt i grundläggande svenska/SVA, matematik, engelska"}>Engelska<br/>Matematik<br/>Svenska/SVA</div>),
                    formatter: () => '',
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '9rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell) => cell ? "bg-light-green" : "bg-light-red"
                }, {
                    dataField: 'allGoals',
                    text: 'Alla mål',
                    isDummyField: true,
                    style: {
                        textAlign: 'center'
                    },
                    headerStyle: {
                        width: '6rem',
                        textAlign: 'center'
                    },
                    headerClasses: 'sticky-y',
                    classes: (_, row) => row.allGoals ? "bg-light-green" : "bg-light-red"
                }, {
                    dataField: 'merit',
                    text: 'Meritvärde',
                    formatter: (cell) => (<div>{cell.points}{cell.uncertain ? '' : ''}</div>),
                    style: {
                        textAlign: 'center',
                    },
                    headerStyle: {
                        textAlign: 'center',
                        width: '8rem'
                    },
                    headerClasses: 'sticky-y',
                    classes: (cell, row) => internal.getPointsColor(row.programType, cell, true, year) 
                }];
            }
        }
    }
    public static sortCourseId = function (courseId: string) {
        if (courseId.startsWith("ENG"))
            return 5;
        else if (courseId.startsWith("SVE"))
            return 4;
        else if (courseId.startsWith("SVA")) 
            return 3;
        else if (courseId.startsWith("MAT"))
            return 2;
        else if (courseId == "SV")
            return 3;
        else if (courseId == "MA")
            return 2;
        else if (courseId == "EN")
            return 1;
        else if (courseId.startsWith("GYAR"))
            return -1;
        else
            return 0;
    };

    public static getColumnsColor = function (isPrognosis : boolean, input?:{grade?: string, prognosis?: number, prevPrognosis?: number}, row:any = {}) {
        if(input == undefined)
            return 'bg-grey';

        const grade = input ? input.grade : undefined;
        const prognosis = input ? input.prognosis : undefined;
        const prevPrognosis = input ? input.prevPrognosis : undefined;
        const grades : { [key: string]: string } = {
            'A':'bg-green',
            'B':'bg-green',
            'C':'bg-green',
            'D':'bg-light-green',
            'E':'bg-light-green',
            'F':'bg-red'
        };
        const prognosises = ['','bg-red','bg-yellow','bg-light-green','bg-green','bg-blue'];
        // console.log({grade,prevPrognosis,prognosis});
        if(grade){
            return grades[grade];
        }
        if(prevPrognosis && !isPrognosis){
            return prognosises[prevPrognosis];
        }
        if(prognosis && isPrognosis){
            //console.log({row})
            return prognosises[prognosis];
        }
        return '';
    };

    public static constructAdditionalColumn = function (course: any, zIndex: number) {
        const column: ColumnDescription<any, any> = {
            dataField: course.id,
            text: course.displayName,
            headerFormatter: (column: any, columnIndex: any) => {
                return (<div 
                    style={{ width:'2rem', height: '14rem', /*position: 'absolute'*/ }}
                    title={course.displayName}
                >
                    <div className="rotated-course-name" >
                        { course.displayName }
                    </div>
                </div>);
            },
            formatter: (cell: any, _) => {
                return (<div style={{ height: '100%', width: '100%', padding: '0.75rem' }}>
                    {cell ? cell.grade != null ? cell.grade : cell.prognosis > 0 ? Prognosis.enum[cell.prognosis].hsName : '' : ''}
                </div>)
            },
            sort: true,
            headerStyle: { width: '3rem', borderRightColor: 'transparent', zIndex: zIndex },
            headerClasses: 'sticky-y',
            style: { padding: 0, textAlign: 'center' },
            classes: (cell) => internal.getColumnsColor(true, cell)
        }

        return column;
    };
    
    private static getCellText = (cell : any, isPrognosis : boolean) => {
        if(!cell)
            return ""
        if((cell.grade != null && cell.grade != '') && !isPrognosis)
            return cell.grade;
        if(cell.prevPrognosis && !isPrognosis)
            return "";//return Prognosis.enum[cell.prevPrognosis].msName;
        if(cell.prognosis > 0 && isPrognosis)
            return Prognosis.enum[cell.prognosis].msName;  
        return "";
    }

    public static constructAdditionalMiddleSchoolColumn = function (course: any, isPrognosis: boolean, zIndex: number) {
        const formatter = isPrognosis ?
                            (cell: any, row: any) => <div/>//<div >{row[course.id]?.grade}</div>
                          : (cell: any) => (<div style={{ height: '100%', width: '100%', padding: '0.75rem' }}>
                                    {internal.getCellText(cell, isPrognosis)}
                                </div>)                              
        const column: ColumnDescription<any, any> = {
            dataField: course.id + (isPrognosis ? '_prognosis' : ''),
            text: course.displayName,
            isDummyField: isPrognosis,
            headerFormatter: (column: any, columnIndex: any) => {
                return (<div 
                    style={{ width:'2rem', height: '14rem', /*position: 'absolute'*/ }}
                    title={course.displayName}
                >
                    <div className="rotated-course-name" >
                        { course.displayName }
                    </div>
                </div>);
            },
            formatter: formatter,
            sort: true,
            headerStyle: { width: '3rem', borderRightColor: 'transparent', zIndex: zIndex },
            headerClasses: 'sticky-y',
            style: { padding: 0, textAlign: 'center' },
            classes: (cell, row) => {
                if(isPrognosis && row[course.id]?.inactive) {
                    return 'bg-grey'
                }
                
                return row[course.id] !== undefined ? internal.getColumnsColor(isPrognosis, { prognosis: row[course.id].prognosis, grade: cell?.grade, prevPrognosis: row[course.id].prevPrognosis }, {...row, course}) : 'bg-grey'
            }
        }
        return column;
    };
}